import styled from "styled-components";
export var FlagImg = styled.img.withConfig({
    componentId: "sc-5e70d93a-0"
})([
    "width:16px;height:12px;margin-right:5px;position:relative;top:1px;"
]);
